//libs
import React, { memo } from 'react';
import useTheme from '@nykaa/ui-components/themes/hooks/useTheme';
import isEmpty from 'lodash/isEmpty';

//styles
import { HeaderText, HeaderIcon, HeaderContainer, HeaderDetails } from './styles';

//defs
import { Theme } from '@nykaa/ui-components/themes/types';

interface IProductHeaderProps {
  headerDetails: Listing.IProductHeader | undefined;
}

const ProductHeader = ({ headerDetails }: IProductHeaderProps) => {
  const theme: Theme = useTheme();
  if (isEmpty(headerDetails) || headerDetails === undefined) return null;
  const { bgColor = '', titleColor = '', title = '' } = headerDetails;
  return (
    <HeaderContainer background={bgColor}>
      <HeaderDetails data-test="header-details">
        <HeaderIcon color={theme.colors.surface} data-test="header-icon" />
        <HeaderText color={titleColor} data-test="header-text">
          {title}
        </HeaderText>
      </HeaderDetails>
    </HeaderContainer>
  );
};

export default memo(ProductHeader);
